import { makeStyles } from '@mui/styles';
import React from 'react';

import ExternalApiResultTable from './ExternalApiResultTable';
import SavedSearchesTable from '../../../../components/SavedSearchesTable';
import MultiSelectCell from '../../../../components/TableSelect/MultiSelectCell';
import { selectAllHeader } from '../../../../components/TableSelect/MultiSelectHeader';
import SingleSelectCell from '../../../../components/TableSelect/SingleSelectCell';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { DATALOOKUP_TYPE_EXTERNAL_API } from '../../../constants/form-manager.constants';

const useStyles = makeStyles({
  savedSearchContainer: {
    '& thead > tr > th:nth-child(1) > svg': {
      display: 'none !important',
    },
  },
});

const ZoomTable = ({
  entityName,
  initialSearchName,
  translatedSearchName,
  dataKey,
  customFilter = [],
  referencedColumns = {},
  dynamicParamCollection = {},
  dataLookUpType,
  multiSelect = false,
  selections = [],
  onMultiSelect = () => {},
  onSingleSelect = () => {},
  onSavedSearchChange = () => {},
  onHeaderMultiselect = () => {},
}) => {
  const translateString = useTranslation();
  const classes = useStyles();

  const extraColumns = [
    {
      header: multiSelect ? (rows) => selectAllHeader(rows, onHeaderMultiselect, selections) : '',
      accessor: multiSelect ? 'SELECT_ALL_HEADER' : 'select',
      customCell: multiSelect
        ? MultiSelectCell(selections, onMultiSelect)
        : (columns) => SingleSelectCell(onSingleSelect, columns),
      fixedWidth: true,
      index: 0,
    },
  ];

  return (
    <>
      {dataLookUpType === DATALOOKUP_TYPE_EXTERNAL_API ? (
        <ExternalApiResultTable
          extraColumns={extraColumns}
          dynamicParamCollection={dynamicParamCollection}
          rowsPerPageOptions={[10, 25, 50]}
        />
      ) : (
        <div className={multiSelect ? classes.savedSearchContainer : null}>
          <SavedSearchesTable
            title={translateString('Records')}
            entityName={entityName}
            initialSearchName={initialSearchName}
            initialTranslatedSearchName={translatedSearchName}
            dataKey={dataKey}
            customFilter={customFilter}
            referencedColumns={referencedColumns}
            dynamicParamCollection={dynamicParamCollection}
            rowsPerPageOptions={[10, 25, 50]}
            extraColumns={extraColumns}
            enableSorting
            showSearchSelector={false}
            onSavedSearchChange={onSavedSearchChange}
            showFilters
          />
        </div>
      )}
    </>
  );
};

export default ZoomTable;
